import { render, staticRenderFns } from "./NewSampleRequestBody.vue?vue&type=template&id=50582e3a&"
import script from "./NewSampleRequestBody.vue?vue&type=script&lang=js&"
export * from "./NewSampleRequestBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports